import React from "react";

const MyMonsters: React.FunctionComponent = () => <div>This is a list of all my monsters:</div>;

export default MyMonsters;
